import * as React from "react";
import Spinner from "../../components/Spinner";
import { Redirect } from "react-router-dom";
import MapContainer from "../../components/Map";
import ArticleScreenSlider from "./ArticleScreenSlider";
import ArticleScreenGallery from "./ArticleScreenGallery";
import { ARTICLE_MAIN_PAGE_ID } from "../../utils/config";

class ArticleScreen extends React.Component {
  componentWillReceiveProps(nextProps) {
    this.loadArticle(nextProps);
  }

  componentDidMount() {
    const { getArticleList, articleList } = this.props;
    this.loadArticle(this.props);
    // load article list only in did mount in a case this page will be 1st opened eg: /ios
    if (!articleList || !articleList.length) {
      getArticleList();
    }
  }

  componentDidUpdate = () => {
    this.loadArticle(this.props);
    const { article } = this.props.articles;
    if( article ) {
      document.title = article.title
    }
  };

  loadArticle = (currentProps) => {
    const {
      articles: { article, articleList },
      location,
      customArticleId
    } = currentProps;
    if (!articleList || !articleList.length) return;
    const locationArticle = location ? location.article : undefined;
    const articleId = locationArticle || customArticleId || ARTICLE_MAIN_PAGE_ID
    if (!article || article.id !== articleId) {
      this.props.getArticle(articleId);
    }
  };

  componentWillUnmount() {
    this.props.clearArticleDetail();
  }

  render() {
    const { article } = this.props.articles;
    // if (location.pathname === "/article" && !articles.article) {
    //   console.log('EXIT1', articles)
    //   return <Redirect to="/" />;
    // }

    if (article === null) return <Spinner />;
    else if (!article.description) {
      return <Redirect to="/" />;
    } else
      return (
        <React.Fragment>
          <ArticleScreenSlider images={article.articleImages} />

          {article.articleImage && false && (
            <div className="container-fluid p-0">
              <div
                className=" text-center header-image"
                style={{ backgroundImage: `url(${article.articleImage})` }}
              ></div>
            </div>
          )}

          <div
            className={`container article-container ${
              article.articleImages && article.articleImages.length
                ? `main-container-with-image`
                : "main-container"
            } mb-3`}
          >
            <div className="row mt-1">
              <div className="col-md-12">
                <div
                  dangerouslySetInnerHTML={{
                    __html: article.description,
                  }}
                ></div>

                {article.center && (
                  <MapContainer
                    initialCenter={{
                      lat: article.center.lat,
                      lng: article.center.lng,
                    }}
                    zoom={16}
                  />
                )}
              </div>
            </div>
            <ArticleScreenGallery images={article.galleryImages} />
          </div>
        </React.Fragment>
      );
  }
}

export default ArticleScreen;



// WEBPACK FOOTER //
// ./src/screens/MainPage/ArticleScreen.js